import { useState, useEffect, useCallback } from 'react'

export const useUnsavedChanges = (hasChanges: boolean) => {
  const [showModal, setShowModal] = useState(false)
  
  // Handle browser unload
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (hasChanges) {
        e.preventDefault()
        e.returnValue = ''
      }
    }
    
    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => window.removeEventListener('beforeunload', handleBeforeUnload)
  }, [hasChanges])
  
  const proceed = useCallback(() => {
    setShowModal(false)
  }, [])
  
  const reset = useCallback(() => {
    setShowModal(false)
  }, [])
  
  return {
    showModal,
    setShowModal,
    proceed,
    reset
  }
}